import { jsx as E } from "react/jsx-runtime";
import { BadRequest as M } from "@systemeio/util";
import P from "../../../../ui-kit/theme-button.mjs";
import { stripeCardBuyOffer as _, confirmPaymentIntent as q } from "../../api/stripe-api.mjs";
import { useStripe as x, useElements as D } from "../../../../node_modules/@stripe/react-stripe-js/dist/react-stripe.esm.mjs";
import { getStripeCardConfirmHandler as H } from "../utils/get-stripe-card-confirm-handler.mjs";
import { useStore as O } from "../../../../store/index.mjs";
import { twJoin as T } from "tailwind-merge";
function A({
  isFetching: f,
  buttonTitle: d,
  buttonDisabled: u,
  setErrors: i,
  setIsFetching: a,
  preSubmit: p,
  handleBadRequest: y,
  hasErrors: w
}) {
  const { locale: h } = O(), r = x(), n = D(), g = async (b) => {
    if (b.preventDefault(), !(!r || !n)) {
      a(!0);
      try {
        const t = p();
        if (!t) return;
        const { error: S } = await n.submit();
        if (S) return;
        const { paymentMethod: o, error: m } = await r.createPaymentMethod({
          elements: n,
          params: {
            billing_details: {
              address: {
                country: null,
                line1: null,
                line2: null,
                city: null,
                state: null,
                postal_code: null
              }
            }
          }
        });
        if (m) {
          i((e) => ({
            ...e,
            common: [...e.common, m.message]
          }));
          return;
        }
        if (!o)
          throw Error("undefined payment method");
        const { redirect: s, intentSecret: l, intentType: C } = await _(
          { ...t, options: { stripePaymentMethodId: o.id } },
          h
        );
        if (!l) return window.location.href = s;
        const B = H(r, C), { error: c } = await B(l, {
          payment_method: o.id
        });
        c ? i((e) => ({ ...e, common: [...e.common, c.message] })) : (await q(), window.location.assign(s));
      } catch (t) {
        if (t instanceof M)
          y(t);
        else
          throw t;
      } finally {
        a(!1);
      }
    }
  };
  return /* @__PURE__ */ E(
    P,
    {
      disabled: u,
      className: T("main-transition-colors", w && "bg-danger focus:bg-danger"),
      onClick: g,
      isFetching: f,
      type: "submit",
      children: d
    }
  );
}
export {
  A as StripeCardPaymentButton
};
